// React
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Grid, IconButton, Toolbar, Typography, styled, Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { filter as stuFilter } from "./Voucher.utils";
import { Form, Formik } from "formik";
import GoForm from "../../../components/Inputs/GoForm";
import { StyledDrawerForm } from "../../../configs/GoStyles";
import EntityConstants from "../../../configs/EntityConstants";
import { get } from "../../../services/FetchHelper";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    minHeight: "50px",
    display: "flex",
    padding: "16px"
}));

const Filter = ({ queryFilters, openFilter, onClose, onFilters }) => {
    const [filter, setFilter] = useState(stuFilter.state);
    const [formFields, setFormFields] = useState(stuFilter.formFields);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getList = async () => {
        const requests = [
            get(EntityConstants.ACCOUNTS, "max=all"),
        ]
        const responses = await Promise.all(requests);
        const [accounts] = await Promise.all(responses.map(response => response.json()));
        attachOptions("accounts", accounts)
    };


    useEffect(() => {
        if (queryFilters !== "{}") {
            setFilter(JSON.parse(queryFilters))
        }
        getList();
    }, []);

    return (
        <Dialog
            open={openFilter}
            onClose={() => onClose()}
            PaperProps={{
                style: {
                    width: "350px",
                },
            }}
        >
            <StyledToolbar>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    Filter
                </Typography>
                <IconButton color="info" onClick={onClose}>
                    <CloseRoundedIcon />
                </IconButton>
            </StyledToolbar>
            <Divider />
            <Formik
                enableReinitialize
                initialValues={filter}
                validationSchema={stuFilter.schema}
                onSubmit={(values) => { onFilters(values); onClose() }}
            >
                {({
                    values,
                    touched,
                    errors,
                    handleChange,
                    handleSubmit,
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <StyledDrawerForm>
                            <DialogContent>
                                <Grid
                                    container
                                    maxWidth="sm"
                                    rowSpacing={1}
                                    columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                                >
                                    {formFields.map((formField, index) => {
                                        return (
                                            <Grid key={index} item xs={12} sm={12} md={12} lg={12}>
                                                <GoForm
                                                    config={formField}
                                                    values={values}
                                                    touched={touched}
                                                    errors={errors}
                                                    handleChange={handleChange}
                                                />
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => { onFilters({}); setFilter(stuFilter.state); onClose() }} color="primary">
                                    Reset
                                </Button>
                                <Button color="primary" type="submit">
                                    Apply Filter
                                </Button>
                            </DialogActions>
                        </StyledDrawerForm>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

Filter.propTypes = {
    openFilter: PropTypes.any,
    onClose: PropTypes.any,
};

export default Filter;
